import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Descarga digital', 'Pago único', 'Sin suscripciones', 'Acceso inmediato'];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-111" data-mp="9k0b6xwjpxkw">
      <div className="mx-auto flex max-w-5xl flex-col items-center px-5 pb-16 pt-6 text-center sm:pt-10 lg:pb-20" data-id="element-112" data-mp="9ih0rnxkmgr1">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[1.95rem] font-black leading-[1.06] tracking-[-0.01em] text-ink xs:text-4xl sm:text-5xl sm:leading-[1.02] lg:text-[4.4rem]" data-id="element-113" data-mp="1297aw07qkt7q">
          Aprende Inglés de A1 a C2 de Forma Visual con{' '}
          <span className="italic text-coral" data-id="element-114" data-mp="3d1s9sv56tfs2">+300 Mapas Mentales</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-115" data-mp="3825zatgqudmy">
          +1200 personas ya estudian de forma fácil y organizada, sin perder horas entre apuntes y explicaciones interminables.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 w-full" data-id="element-116" data-mp="3e7l8s54oaqkr">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/86cc7af7-61df-4c0e-8d7b-47ec2f040c22.jpg" alt="Pack de +300 mapas mentales de inglés en monitor, tablet y teléfono, con los seis cuadernos por nivel A1 a C2 y los tres bonos: 500 frases más usadas, English Practice Master Kit y 100 verbos frasales esenciales" className="mx-auto w-full max-w-3xl" width={1200} height={900} data-id="element-117" data-mp="2qkwkn1p2m1vp" />
        </motion.div>

        

        <div className="mt-9 flex w-full justify-center" data-id="element-118" data-mp="s3cloaja7jqk">
          <CtaButton data-id="element-119" data-mp="nb1j0zx5pjub">Obtén el Pack +300 Mapas Mentales de Inglés™</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-120" data-mp="ibowkga76es9">
          {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-121" data-mp="1b0nkju104b5h" data-mpi={index}>
              {index > 0 ? <span aria-hidden="true" className="text-line" data-id="element-122" data-mp="1ayjilhmnxm7u">•</span> : null}
              <span data-id="element-123" data-mp="162m137zny9th">{item}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}